module.exports = __webpack_public_path__ + "static/media/aw.3f52fb17.svg";